import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCsvImport } from "../../../../lib/useCsvImport";
import { Layout } from "../../../../ui/layout";
import { MenuItems } from "../../../../ui/organisms/navbar/dto";
import { ImportCSVResponseDTO } from "../../dto";
import { ImportModalContacts } from "./modal";
import { Step1 } from "./step1";
import { Step2 as CompaniesStep2 } from "./step2Companies";
import { Step2 as PeopleStep2 } from "./step2People";

export function ImportDatabase() {
  const tabValue = useParams().tab;
  const [step, setStep] = useState(0);
  const [name, setName] = useState("");
  const [delimiter, setDelimiter] = useState("");
  const [fields, setFields] = useState<string[]>([]);
  const [file, setFile] = useState<File | null>(null);
  const [rows, setRows] = useState<Record<string, any>[]>([]);
  const [importResponse, setImportResponse] = useState<ImportCSVResponseDTO | undefined>();
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const resetFileState = () => {
    setName("");
    setDelimiter("");
    setFields([]);
    setRows([]);
    setFile(null);
  };

  const { handleFileChange } = useCsvImport(
    resetFileState,
    setName,
    setDelimiter,
    setFields,
    setRows,
    setFile
  )

  return (
    <Layout
      menuItem={MenuItems.DATABASE}
      breadcrumbItems={["Database", `(Importa ${tabValue === 'people' ? 'persone' : 'aziende'})`]}
      headerLabel={`Importa ${tabValue === 'people' ? 'persone' : 'aziende'}`}
      headerBackPath={`/database/${tabValue}`}
    >
      <div className="p-4 h-full max-h-full">
        <div className="rounded-xl shadow-sm h-full flex flex-col bg-white gap-10 justify-between max-h-full">
          {step === 0 && (
            <Step1
              step={step}
              setStep={function (value: number): void {
                setStep(value);
              }}
              handleChange={function (e: File[]): void {
                handleFileChange(e);
              }}
              file={file}
            />
          )}
          {step === 1 && (
            tabValue === 'people' ?
              <PeopleStep2
                step={step}
                setStep={function (value: number): void {
                  setStep(value);
                }}
                name={name}
                delimiter={delimiter}
                fields={fields}
                file={file}
                rows={rows}
                onImportSuccess={(response) => {
                  setImportResponse(response);
                  setShowModal(true);
                }}
                onImportError={() => {
                  setShowModal(true);
                }}
              /> :
              <CompaniesStep2
                step={step}
                setStep={function (value: number): void {
                  setStep(value);
                }}
                name={name}
                delimiter={delimiter}
                fields={fields}
                file={file}
                rows={rows}
                onImportSuccess={(response) => {
                  setImportResponse(response);
                  setShowModal(true);
                }}
                onImportError={() => {
                  setShowModal(true);
                }}
              />
          )}
        </div>
      </div>

      <ImportModalContacts
        importResponse={importResponse}
        showModal={showModal}
        onClose={() => {
          setShowModal(false);
          setImportResponse(undefined);
          navigate(-1);
        }}
      />
    </Layout>
  );
}
